import React from "react"
import { Content, List, ContentTitle } from './styles'
import { FiArrowDown } from "react-icons/fi";
import CardPost from '../CardPost'
import Button from '../Button'

function PostsHome({ posts }) {

  return (
    <Content>
      <ContentTitle>
        <h2>Publicado Recentemente</h2>
        <FiArrowDown strokeWidth='4px' size="1.8rem" />
      </ContentTitle>

      <List>
        {posts.map(post =>{
          return (
             post.node.frontmatter.isVisible && <CardPost key={post.node.id} post={post} />
          )
        }
        )}
      </List >
      <Button link="/blog" text="Ver mais" />
    </Content >

  )
}

export default PostsHome
